
import { Component } from '@angular/core';
import { AddnewSubregion, contentmanager, Locations } from 'src/app/Models/contentmanager';
import { ConfirmationServiceService } from 'src/app/Services/confirmation-service.service';

import { ContentManagerService } from 'src/app/Services/content-manager.service';
import { CustomToasterServiceService } from 'src/app/Services/custom-toaster-service.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
@Component({
  selector: 'app-conten-manager',
  templateUrl: './conten-manager.component.html',
  styleUrls: ['./conten-manager.component.css']
})
export class ContenManagerComponent {
isSaving: boolean = false;
isRegionSaving: boolean = false;

  Addregion: boolean = false
  showAfrica: boolean = false
  showmaincontent: boolean = true
  showedit: boolean = false
  showsubrigin: boolean = false
  editsubregion: boolean = false
  showarrow: boolean = false
  AddnewSubregion: boolean = false
  subafrica: boolean = false
  showlocation: boolean = false
  Addnewlocatin: boolean = false
  expandedRegionId: number = 0;
  expandedsubRegionId: number = 0;
  regionIdstore: number = 0
  subregionid: number = 0
  Backsubrigion: boolean = false
  selectedFile: File | null = null;
  locselectedFile: File | null = null;
  subselectedFile: File | null = null;
  UserId: number = 0;
  regionid: number = 0
  regionurl: string | null = null;
  subrigionid: number = 0
  locationid = 0
  locationurl: string | null = ''
  hideimgregion: boolean = false
  showaddimg: boolean = false
  showloc: boolean = false
  editname: boolean = false
  editsubrigionname: boolean = false
  editlocationname: boolean = false
  subregionList: any[] = []
  locationarray: any[] = []
  locid: number = 0
  isreadonly:boolean=false
  editimage: boolean = false;
  visibleLocationCards: { [locationId: number]: boolean } = {};
  visibleLocationCardsname: { [locationId: number]: boolean } = {};
isEditing: boolean = false;
editingLocations: { [key: number]: boolean } = {};

  constructor(private contentservice: ContentManagerService,
    private toasterService: CustomToasterServiceService,
    private confirmDialogService: ConfirmationServiceService) { }

  AddNewRegion: contentmanager =
    {
      regionId: 0,
      regionName: '',
      regionDisplayImageUrl: '',
      createdAt: new Date(),
      updatedAt: new Date(),
      subRegions: [],
      locations: []

    }
  currentlocationname: string = ''

  displayregioncontent: contentmanager[] = []

  Addsubrigions: AddnewSubregion =
    {
      subRegionId: 0,
      regionId: 0,
      subRegionName: '',
      subRegionDisplayImageUrl: '',
      createdAt: new Date(),
      updatedAt: new Date(),
      locations: []
    }

  editingLocationId: number=0;

  AddLocationobj: Locations = {
    locationId: 0,
    subRegionId: 0,
    locationName: '',
    locationDisplayImageUrl: '',
    createdAt: new Date(),
    updatedAt: new Date(),
    langitude: 0,  // matches backend JSON key
  latitude: 0
  };


  
  Editnames() {
    this.editimage = true;
  }

  cancelEdit() {
    this.editimage = false;
  }

  storeidfun(regionIdstr: number) {

    this.regionIdstore = regionIdstr
  }

  ngOnInit(): void {

    this.Displayregion()
    this.storesubid(this.subregionid)
  
  const storedData = sessionStorage.getItem('userData');
  const newProfilePhoto = sessionStorage.getItem('ProfileImage');

  if (storedData) {
    const parsedData = JSON.parse(storedData);


    this.UserId = parsedData.userId;
 

    this.storeidfun(this.regionIdstore);
  } else {

  }

  }
locationupdatepart(locationid: number, name: string | null) {
  this.locid = locationid;



  this.visibleLocationCards = {};
  this.visibleLocationCards[locationid] = true;
}

  Editname() {
    this.editname = true
  }

  subrigionname() {
    this.editsubrigionname = true
  }
  locationname(location: number) {
    this.editlocationname = true
    this.visibleLocationCardsname[location] = !this.visibleLocationCardsname[location];

  }
  locationidd = 0
  editLocation(locationId: number) {
    debugger
  this.locid = locationId;
  if (this.editingLocationId === locationId) {
    this.locationidd = locationId;
    this.editingLocationId = 0; 
  } else {
    this.editingLocationId = locationId; 
  }
}


  selectedRegion: any = null;
  showafica(regionId: number) {
    debugger;

if(! this.showedit &&  !this.editsubregion )
{
const isSameRegion = this.expandedRegionId === regionId;

  if (isSameRegion) {
  
    this.expandedRegionId = 0;
    this.showAfrica = false;
    this.subafrica = false;
    this.showmaincontent = true;
  } else {
    
    this.expandedRegionId = regionId;
    this.selectedRegion = this.displayregioncontent.find(r => r.regionId === regionId);
    this.showAfrica = true;    
    this.subafrica = true;
    this.showmaincontent = false; 
  }


  this.expandedsubRegionId = 0;
  this.showsubrigin = false;
  this.showlocation = false;


  this.Addregion = false;
  this.showaddimg = false;
  this.Addnewlocatin = false;
  this.AddnewSubregion = false;
  this.showedit = false;
  this.shoaddloc = false;

 
}
else
  if (this.showedit) {
  this.confirmDialogService.openConfirmDialog(
    `Do You want Save changes`,
    () => {
      this.nameAddRegionpost();
      this.updatesuborder();
    }, 'assets/confirmation-msg/saveChange.svg' );
}


      if( this.editsubregion)
      {
this.confirmDialogService.openConfirmDialog(
    `Do You want Save changes`,
    () => {
     this.updatenameAddnewLocationfun()
    }, 'assets/confirmation-msg/saveChange.svg' );
      }
  
  


  }


  backtoregion() {
    this.AddnewSubregion = false
    this.subafrica = true
    this.showedit = false
    this.hideimgregion = false
    this.editname = false
    this.showmaincontent = false
    this.showAfrica = true
    this.cancelEdit()
  }

  storesubid(subid: number) {
    this.subregionid = subid
  }


  showeditfunction() {
    this.showedit = !this.showedit
    this.Addregion = false
    this.showaddimg = false
    this.AddNewRegion.regionDisplayImageUrl=null
    this.oncancel
    this.Editnames()
  }

  showsubrigion(subid: number) {
    debugger;

if(! this.showedit &&  !this.editsubregion )
{
 if (this.expandedsubRegionId !== subid) {
      this.expandedsubRegionId = subid;

      this.showsubrigin = true;
      this.showmaincontent = false;
      this.showAfrica = false;
      this.shoaddloc = true;
      this.Addregion = false;
      this.showaddimg = false;
      this.subafrica = false;
      this.AddnewSubregion = false;
      this.showlocation = true;
      this.Addnewlocatin = false;
    }
}

else
  if (this.showedit) {
  this.confirmDialogService.openConfirmDialog(
    `Do You want Save changes ?`,
    () => {
      this.nameAddRegionpost();
      this.updatesuborder();
    }, 'assets/confirmation-msg/saveChange.svg' );
}


      if( this.editsubregion)
      {
this.confirmDialogService.openConfirmDialog(
    `Do You want Save changes ?`,
    () => {
     this.updatenameAddnewLocationfun()
    }, 'assets/confirmation-msg/saveChange.svg');
      }
  
  
    
  
   
          




    
  }



  showeditsubregion() {
    if(! this.showedit &&  !this.editsubregion )
    {
       this.editsubregion = true
    this.Addregion = false
    this.showaddimg = false
this.subrigionname()
this.Editnames()
        this.isEditing = true;
    }
   
this.isreadonly=true
this.Addsubrigions.subRegionName=""
  }
  oncancel() {
    this.regionurl = null
        this.AddNewRegion.regionName = null;
  }
  onloccancel() {
    this.locationurl = null
  }


  Addnewregion() {
    this.showedit = false
    this.showsubrigin = false
    this.shoaddloc = false
    this.editsubregion = false
    this.Addregion = !this.Addregion
    this.showaddimg = !this.showaddimg
    this.showAfrica = false
    this.showmaincontent = true
    this.subafrica = false
    this.AddnewSubregion = false
    this.showlocation = false
    this.Addnewlocatin = false
    this.AddNewRegion.regionId = 0
    this.AddNewRegion.regionName = null

    this.oncancel()
  }

  showAddnewsubregion() {
    this.showedit = false
    this.showsubrigin = false
    this.shoaddloc = false
    this.editsubregion = false
    this.Addregion = false
    this.showAfrica = true
    this.showmaincontent = false
    this.AddnewSubregion = !this.AddnewSubregion
    this.subafrica = false
    this.Addregion = false
    this.showaddimg = false
    this.showlocation = false
    this.Addnewlocatin = false
     this.Addsubrigions.subRegionName = ""


  }



  Displayregion() {
    debugger
    this.contentservice.ShowRegion().subscribe((res: contentmanager[]) => {

      this.displayregioncontent = res
      this.displayregioncontent = res


    })
  }
  dropSubregion(event: CdkDragDrop<any[]>, subregionList: any[]) {
    moveItemInArray(subregionList, event.previousIndex, event.currentIndex);

    this.subregionList = subregionList.map(s => s.subRegionId)
  }


  drop(locationsArray: any[], event: CdkDragDrop<any[]>) {
    moveItemInArray(locationsArray, event.previousIndex, event.currentIndex);
    this.locationarray = locationsArray
   
    this.locationarray = locationsArray.map(l => l.locationId)
  }



  shoaddloc: boolean = false
  AddnewLocation() {
    this.Addnewlocatin = true
    this.showlocation = false
    this.showsubrigin = false
    this.AddLocationobj.locationId = 0
this.AddLocationobj.locationName=null
    this.shoaddloc = true
    
  }
  backtosubrigion() {
    debugger
    this.Addnewlocatin = false
    this.showlocation = true
    this.showsubrigin = true
    this.onloccancel()



  }

AddRegionpost() {


  if (this.isRegionSaving) {
    return;
  }

  if (
    !this.AddNewRegion.regionName ||
    this.AddNewRegion.regionName.trim() === '' ||
    this.selectedFile === null
  ) {
    this.toasterService.error("Required Fields cannot be empty.");
    return;
  }

  // 🔒 Disable button + show spinner
  this.isRegionSaving = true;

  this.contentservice.Addregion(this.AddNewRegion).subscribe({
    next: (res) => {
      this.regionid = res.regionId;

      if (this.AddNewRegion.regionId === 0) {
        this.toasterService.success("Region Added Successfully");
      } else {
        this.toasterService.success("Region Updated Successfully");
      }

      this.showmaincontent = false;
      this.Addregion = true;

      setTimeout(() => {
        this.Displayregion();
        this.Addnewregion();
        this.uploadimgeregion();
      }, 2000);
    },
    error: (err) => {
      if (err.status === 400 && err.error) {
        this.toasterService.error(
          `Bad Request: ${err.error.message || err.error}`
        );
      } else {
        this.toasterService.error("Something went wrong. Please try again.");
      }
    },
    complete: () => {
      // 🔓 Re-enable button
      this.isRegionSaving = false;
    }
  });
}



  nameAddRegionpost() {
    debugger;
    if(this.AddNewRegion.regionName)
    {
       this.selectedRegion.regionName
    if (this.expandedRegionId) {
      this.AddNewRegion.regionId = this.expandedRegionId
    }
  


    if (this.AddNewRegion.regionId > 0 && this.AddNewRegion.regionName == null) {
     
    }
   this.contentservice.Addregion(this.AddNewRegion).subscribe({
  next: (res) => {
    this.regionid = res.regionId;
    this.selectedRegion.regionName = res.regionName;
     this.AddNewRegion.regionName = this.selectedRegion.regionName

    if (this.selectedFile && this.AddNewRegion.regionName) {
      this.toasterService.success("Updated Image successfully");
    } else {
      this.toasterService.success("Region Updated successfully");
    }

    this.AddNewRegion.regionName = null;
  },
  error: (err) => {
    if (err.status === 400) {
      this.toasterService.error("Region Already exists. Please choose a different name.");
      this.AddNewRegion.regionName = null;
    } else {
      this.toasterService.error("An error occurred. Please try again later.");
    }

    console.error("Error response:", err);
  }
});

      
    }
     if (this.expandedRegionId) {
        this.backtoregion()
      }

      setTimeout(() => {
        this.Displayregion();
      }, 2000);

      if (this.selectedFile) {
             this.uploadimgeregion();
      }
 
      this.regionurl;


  }


  onFileSelected(event: Event): void {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        this.regionurl = reader.result as string;  
      };
      reader.readAsDataURL(file);
      this.selectedFile = file

    }
  }
  locationPreviewUrls: { [locationId: number]: string } = {};

  onlocFileSelected(event: Event,locationId: number): void {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        this.locationurl = reader.result as string;  
         this.locationPreviewUrls[locationId] = reader.result as string;
      };
      reader.readAsDataURL(file);
      this.locselectedFile = file

    }
  }




  Addsubrigionfun() {
    this.Addsubrigions.regionId = this.expandedRegionId



  if(this.Addsubrigions.subRegionName == null || this.Addsubrigions.subRegionName.trim() === '') {
      this.toasterService.error("Required fields  cannot be empty.");
      return;
    }
    this.contentservice.Addsubrigion(this.Addsubrigions).subscribe((res) => {
      this.subrigionid = res.subRegionId


      setTimeout(() => {
        this.Displayregion();
      }, 2000);

this.backtoregion()
      if (this.Addsubrigions.subRegionId == 0) {
        this.toasterService.success("Subregion added successfully.");
      }
      else {
      

      }

    })
  }




  Addnamamesubrigionfun() {
    debugger


    this.Addsubrigions.regionId = this.expandedRegionId

    this.Addsubrigions.subRegionId = this.expandedsubRegionId



    this.contentservice.Addsubrigion(this.Addsubrigions).subscribe((res) => {
      this.subrigionid = res.subRegionId
    
      this.Addsubrigions.subRegionId = 0
      setTimeout(() => {
        this.Displayregion();
      }, 2000);
this.backtolocation()

       
        this.toasterService.success("Subregion Updated Successfully");

      

    })
  }



kepnullregion()
{

  this.regionurl=null
}



  AddnewLocationfun() {
    debugger
    


    debugger
    this.AddLocationobj.subRegionId = this.expandedsubRegionId;
    this.AddLocationobj.locationId = this.AddLocationobj.locationId
 

    
    this.contentservice.AddLocation(this.AddLocationobj).subscribe((res) => {
     

this.AddLocationobj.locationName=null

      setTimeout(() => {
        this.Displayregion();
      }, 4000);
     
      this.uploadlocationimg()
 this.backtosubrigion()
      if (this.AddLocationobj.locationId == 0) {
        this.toasterService.success("Location Added Successfully");
      }
      else {
       
      }

    })
  }

  updatenameAddnewLocationfun() {
    debugger;
if(this.AddLocationobj.locationName)
{
   this.AddLocationobj.subRegionId = this.expandedsubRegionId;
    this.AddLocationobj.locationId = this.locid;


    if (!this.AddLocationobj.locationName || this.AddLocationobj.locationName.trim() === '') {
   
      
    }

    this.contentservice.AddLocation(this.AddLocationobj).subscribe((res) => {
  
      
if(this.locselectedFile && this.AddLocationobj.locationName )
{
  this.toasterService.success("Location Updated Successfully");
}
      this.AddLocationobj.locationName = null
      this.AddLocationobj.locationId = 0
      this.editingLocationId = 0
      setTimeout(() => {
        this.Displayregion();
      }, 3000);

  

 if(!this.locselectedFile )
 {
this.toasterService.success("Location Updated Successfully");
 }
 
      



      setTimeout(() => {
        this.locationurl = null;
      }, 4000);
    });
}
if(this.Addsubrigions.subRegionName)
 {
  this.Addnamamesubrigionfun() 

 }
    this.uploadlocationimg();
    
    this.backtolocation()
  }

  kepnull() {
    this.locationurl = null
  }


  showaddimgfun() {
    this.showaddimg = true
    this.hideimgregion = true


  }

  BacktoSubrigion() {
    debugger

    this.showarrow = !this.showarrow

    this.showAfrica = true
    this.showmaincontent = false
    this.Addregion = false
    this.showaddimg = false
    this.subafrica = true
    this.showlocation = false
    this.Addnewlocatin = false
    this.showsubrigin = false
    this.shoaddloc = false
    this.expandedsubRegionId = 0
  }

  uploadimgeregion() {

    debugger
    if ( ! this.selectedFile) {
      this.toasterService.error("Please select an image to upload.");
      return;
    }

    
    this.contentservice.regionimageupload(this.UserId, this.regionid || this.expandedRegionId, this.selectedFile).subscribe((res) => {
      setTimeout(() => {

        this.Displayregion();
        this.AddNewRegion.regionDisplayImageUrl=null
        this.selectedFile = null
        this.regionurl = null
      }, 2000);

       if (this.expandedRegionId) {
        this.backtoregion()
      }
    })
  }

  uploadlocationimg() {

    debugger
    if (!this.locselectedFile) {

      return;
    }

    this.contentservice.locationimageupload(this.UserId, this.locationid || this.locid, this.locselectedFile).subscribe((res) => {

      this.AddLocationobj.locationDisplayImageUrl = res.locationDisplayImageUrl;



     if(this.AddLocationobj.locationId!=0){
 this.toasterService.success("Image Uploaded Successfully");
     }

      

      
     

      this.Displayregion()
      this.locationurl
        this.locselectedFile = null; 
        this.locationid=0
    })
  }



  deletesubrigion(subdelleteid: number,subregionName: string) {
    debugger;

    this.confirmDialogService.openConfirmDialog(`Are you sure you want to delete the sub-region "${subregionName}"?
All locations under this sub-region will also be deleted. This cannot be undone. `, () => {
      this.contentservice.deletesubregion(subdelleteid, this.UserId).subscribe((res) => {
        this.Displayregion();
      });
    },'assets/content-manager/deletesub.png');
  }


  backtolocation() {
    debugger
    this.showlocation = true
    this.editsubregion = false
    this.locationurl = null
    this.locselectedFile = null;
    this.visibleLocationCards = {};
    this.editsubrigionname = false
    this.editingLocationId=0
     this.locationPreviewUrls = {};
      this.Displayregion();
    this.cancelEdit()
     this.AddLocationobj = {
    locationId: 0,
    subRegionId: 0,
    locationName: '',
    locationDisplayImageUrl: '',
    createdAt: new Date(),
    updatedAt: new Date(),
    langitude: 0,   
    latitude: 0
  };
this.isEditing=false
  }
  deletelocation(locationid: number,locationName: string|null) {
    debugger;
    this.confirmDialogService.openConfirmDialog(
      `Do you want to delete the location ${locationName}?
This action is permanent and will remove the location from the mobile app and admin dashboard. `,
      () => {
        this.contentservice.deletelocationapi(locationid, this.UserId).subscribe(() => {
          this.Displayregion(); 
        });
      },'assets/content-manager/deleteloc.png'
    );
  }

  updatesuborder() {
    debugger
    this.contentservice.updateSubregionOrder(this.subregionList).subscribe(() => {


    })
  }




  updatelocationorder() {
    debugger
    this.contentservice.updatelocationOrder(this.locationarray).subscribe(() => {
    

    })
  }

  deleteregion() {
    this.confirmDialogService.openConfirmDialog(
      `
Are you sure you want to delete the region "${this.selectedRegion?.regionName || ' Delete this region'}"?
This will also delete all associated sub-regions and locations. This action cannot be undone. `,
      () => {
        this.contentservice.deleteregiononapi(this.expandedRegionId, this.UserId).subscribe(() => {
   
          this.displayregioncontent = this.displayregioncontent.filter(r => r.regionId !== this.expandedRegionId);

          this.expandedRegionId = 0;
          this.showAfrica = false;
          this.subafrica = false;
          this.showmaincontent = true;

          this.toasterService.success("Region Deleted Successfully");

         
          setTimeout(() => {
            this.Displayregion();
          }, 1000);
        });
      }, 'assets/content-manager/deletedr.png'
    );
  }


AddnewLocations() {
  debugger;

  // Prevent double click
  if (this.isSaving) {
    return;
  }

  this.AddLocationobj.subRegionId = this.expandedsubRegionId;
  this.AddLocationobj.locationDisplayImageUrl = this.locselectedFile;

  if (
    this.AddLocationobj.locationId <= 0 &&
    (!this.AddLocationobj.locationName ||
      this.AddLocationobj.locationDisplayImageUrl == null)
  ) {
    this.toasterService.error("Required field missing for location name or image");
    return;
  }

  if (this.AddLocationobj.langitude <= 0 || this.AddLocationobj.latitude <= 0) {
    this.toasterService.error("Latitude and Longitude must be greater than zero.");
    return;
  }

  // 🔒 Disable button
  this.isSaving = true;

  this.contentservice
    .addOrUpdateLocationWithImage(this.AddLocationobj, this.UserId)
    .subscribe({
      next: (res) => {
        const conflict = res.find(r => r.statusCode === 409);
        if (conflict) {
          this.toasterService.error(conflict.message);
          return;
        }

        setTimeout(() => {
          this.Displayregion();
        }, 4000);

        this.backtosubrigion();

        if (this.AddLocationobj.locationId === 0) {
          this.toasterService.success("Location Added Successfully");
          this.AddLocationobj.locationDisplayImageUrl = null;
          this.locselectedFile = null;
        }
      },
      error: () => {
        this.toasterService.error("Something went wrong");
      },
      complete: () => {
        // 🔓 Enable button again
        this.isSaving = false;
      }
    });
}


onLangitudeChange(lang: any) {
    debugger
  this.AddLocationobj.langitude = lang.langitude;
  this.editingLocationId = lang.locationId;
     this.AddLocationobj.locationName = lang.locationName;
}
onlatitudeChange(lat: any) {
  debugger
  this.AddLocationobj.latitude = lat.latitude;
   this.AddLocationobj.locationName = lat.locationName;
  this.editingLocationId = lat.locationId;
}

onLocationNameChange(loc: any) {
  this.AddLocationobj.locationName = loc.locationName;
  this.editingLocationId = loc.locationId;

}
UpdateNewLocation()
{
  debugger
  
  this.AddLocationobj.locationId=this.editingLocationId||this.locid
   this.AddLocationobj.subRegionId = this.expandedsubRegionId;
  this.AddLocationobj.locationDisplayImageUrl=this.locselectedFile

this.contentservice
  .updateLocationAndSubregion(this.AddLocationobj, this.Addsubrigions.subRegionName, this.UserId)
  .subscribe({
    next: (res: any[]) => {
      const conflict = res.find(r => r.statusCode === 409);
      if (conflict) {
        this.toasterService.error(conflict.message);
        return;
      }
  
      
      this.locationurl = null;
      this.locationPreviewUrls = {};
      this.AddLocationobj = {
        locationId: 0,
        subRegionId: 0,
        locationName: '',
        locationDisplayImageUrl: '',
        createdAt: new Date(),
        updatedAt: new Date(),
        langitude: 0,   
        latitude: 0
      };

      setTimeout(() => {
        this.Displayregion();
        this.locselectedFile = null;
      }, 3000);

      this.backtolocation();
      this.isEditing = false;

      if (!this.Addsubrigions.subRegionName) {
        this.toasterService.success("Location Updated Successfully");
      } else {
        this.toasterService.success("Subregion Updated Successfully");
      }
    },

    error: (err) => {
      
      if (err.status === 409) {
        this.toasterService.error(err.error?.message || "Location already exists.");
      } else {
        this.toasterService.error("Something went wrong. Please try again.");
      }

      console.error('Error response:', err);
    }
  });

}

}

